import { RequestKind, boolean, number, string } from '@sb/library/base';
import { DisplayItemCollection, EventCategoryDisplayItem, EventCategoryInputItem, EventCategorySearchOptions, EventCategoryUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace EventCategoryRoutes {
    export const Add = ApiRoute.Define({
        URL: `eventcategories`,
        BodyType: EventCategoryInputItem,
        Kind: RequestKind.Post,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (categoryID: string) => `eventcategories/${categoryID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (eventCategoryID: string) => `eventcategories/${eventCategoryID}`,
        Kind: RequestKind.Get,
        ResultType: EventCategoryDisplayItem
    });

    export const GetCountOfEventsByCategory = ApiRoute.Define({
        URL: (eventCategoryID: string) => `summary/eventcategories/${eventCategoryID}/count`,
        Kind: RequestKind.Get,
        ResultType: number
    });

    export const GetAll = ApiRoute.Define({
        URL: `eventcategories`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<EventCategoryDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: `search/eventcategories`,
        Kind: RequestKind.Post,
        BodyType: EventCategorySearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<EventCategoryDisplayItem>
    });

    export const Update = ApiRoute.Define({
        URL: (categoryID: string) => `eventcategories/${categoryID}`,
        BodyType: EventCategoryUpdateItem,
        Kind: RequestKind.Put,
        ResultType: boolean
    });
}
